import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message, MenuItem, SelectItem, TreeNode } from 'primeng/components/common/api';
import { Utils } from '../../../../../utils';
import { TestService } from '../_service/TestService';
import { Test } from '../_model/Test';
import { query } from '@angular/animations/src/animation_metadata';
import { GenericComponent } from '../../../../layouts/custom-component/generic-component';
import { PageTableComponent } from '../../../../layouts/custom-component/page-table.component';
import { EmailService } from '../_service/EmailService';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { Email } from '../_model/Email';
import { AudioService } from '../_service/AudioService';
import { Premio } from '../_model/Premio';

@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-wrapper",
    templateUrl: './test.component.html',


    providers: [
        TestService, { provide: String, useValue: "TestAF" },
        EmailService,
        AudioService
    ]



})
export class TestComponent extends PageTableComponent implements OnInit {

    audioList: SelectItem[];
    item: Test;
    itemName: string;
    cols: any[];
    loadTableStr: string;
    genericform: FormGroup;

    emailListComplete: any[];
    emailList: any[];
    emailsSelected: any[];
    valDurata: number;

    premiList: any[];
    tempi: any;
    selectedPremi: string[];

    displayDialogTempo: boolean = false;
    tempoAttesa: any = null;
    currEmail: any = null;

    punteggiKeys: any[] = null;

    punteggiKeysNew: any[] = null;

    tipologia: SelectItem[];
    tipologiaFeedback: SelectItem[];
    tipologiaSecEmail: SelectItem[];

    from_random: any = 0;
    to_random: any = 0;

    constructor(private fb: FormBuilder, private ts: TestService, private es: EmailService, private as: AudioService) {
        super(ts);
    }



    ngOnInit() {

        this.tipologia = []
        this.tipologia.push({ label: "Seleziona Tipologia", value: "" });
        this.tipologia.push({ label: "Rapporto Fisso", value: "1" });
        this.tipologia.push({ label: "Rapporto Variabile", value: "2" });
        this.tipologia.push({ label: "Intervallo Fisso", value: "3" });
        this.tipologia.push({ label: "Intervallo Variabile", value: "4" });

        this.tipologiaFeedback = []
        this.tipologiaFeedback.push({ label: "Nessun Feedback", value: "0" });
        this.tipologiaFeedback.push({ label: "Fisso", value: "1" });
        this.tipologiaFeedback.push({ label: "Variabile", value: "2" });

        this.tipologiaSecEmail = []
        this.tipologiaSecEmail.push({ label: "Scegli...", value: "" });
        this.tipologiaSecEmail.push({ label: "Secondi", value: "0" });
        this.tipologiaSecEmail.push({ label: "Email", value: "1" });

        this.valDurata = 0;

        this.item = new Test();
        this.itemName = "test";

        this.emailsSelected = [];
        this.emailList = [];
        this.emailListComplete = [];

        //this.loading = true;
        //this.from_random = 0;
        //this.to_random = 0;




        this.punteggiKeys = [

            { "key": "tokenScambio_7", "name": "Token guadagnati per Mail Sospetta", "placeholder": "Inserisci..." },
            { "key": "tokenScambio_8", "name": "Token guadagnati per Mail Non sospetta", "placeholder": "Inserisci..." },

            { "key": "tokenErratoScambio_7", "name": "Token persi per errore Mail Sospetta", "placeholder": "Inserisci..." },
            { "key": "tokenErratoScambio_8", "name": "Token persi per errore Mail Non sospetta", "placeholder": "Inserisci..." },

            // { "key": "feedbackScambio_7", "name": "Feedback guadagnato per Bottone Sospetta", "placeholder": "Inserisci...", "string": true },
            // { "key": "feedbackScambio_8", "name": "Feedback guadagnato per Bottone Non sospetta", "placeholder": "Inserisci...", "string": true }
        ]



        /*
        this.es.getAll().then((retdata) => {

            this.loading = false;
            Utils.log("ES: ", retdata);
            if (retdata.response == 0) {
                this.emailListComplete = retdata.data.emailList;

            } else {
                this.showMessageError(retdata.errors);
            }

        });
        */


        this.cols = [
            //{ field: 'id', header: 'id', sortable: false },
            { field: 'nome', header: 'Nome', sortable: false },
            //{ field: 'durata', header: 'Durata (sec)', sortable: false },
            // field: 'audioStr', header: 'File audio', sortable: false },
            //{ field: 'timeoutPassword', header: 'Screensaver (sec)', sortable: false }

        ];




        this.genericform = this.fb.group({
            'id': new FormControl(''),
            'nome': new FormControl('', Validators.required),
            "nEmailSospette": new FormControl('', Validators.required),
            "nEmailNonSospette": new FormControl('', Validators.required),
            //'durata': new FormControl('', Validators.required),
            'emails': new FormControl(''),
            //"timeoutPassword": new FormControl('', Validators.required),
            "ritardoPulsanti": new FormControl(''),
            //"pMouseOver": new FormControl(''),
            //"pScreenSaver": new FormControl(''),
            //"timer": new FormControl(''),
            "loopEmail": new FormControl(''),
            //"ordineForzato": new FormControl(''),
            //"area_scrittura": new FormControl(''),
            //"soloPulsanti": new FormControl(''),

            //"passBottone_1": new FormControl('', Validators.required),
            //"passBottone_2": new FormControl('', Validators.required),
            //"passBottone_3": new FormControl('', Validators.required),
            //"passBottone_4": new FormControl('', Validators.required),
            //"passBottone_5": new FormControl('', Validators.required),
            //"passBottone_6": new FormControl('', Validators.required),

            "tipo": new FormControl('', Validators.required),
            "tipoScambio": new FormControl('', Validators.required),
            "valoreIniziale": new FormControl('', Validators.required),
            "valoreFinale": new FormControl(''),
            "valoreInizialeScambio": new FormControl('', Validators.required),
            "valoreFinaleScambio": new FormControl(''),
            "tipoScambioSecEmail": new FormControl('', Validators.required),

            "premi": new FormControl('', Validators.required),

            //"tipoAssegnazioneFeedback": new FormControl(''),
            //"valoreInizialeAssegnazioneFeedback": new FormControl(''),
            //"valoreFinaleAssegnazioneFeedback": new FormControl(''),

            "tempoPremio_1": new FormControl(''),
            "tempoPremio_2": new FormControl(''),
            "tempoPremio_3": new FormControl(''),
            "tempoPremio_4": new FormControl(''),
            "tempoPremio_5": new FormControl(''),
            "tempoPremio_6": new FormControl(''),
            "tempoPremio_98": new FormControl(''),
            "tempoPremio_99": new FormControl(''),

            "costoPremio_1": new FormControl(''),
            "costoPremio_2": new FormControl(''),
            "costoPremio_3": new FormControl(''),
            "costoPremio_4": new FormControl(''),
            "costoPremio_5": new FormControl(''),
            "costoPremio_6": new FormControl(''),
            "costoPremio_98": new FormControl(''),
            "costoPremio_99": new FormControl(''),


            "tokenScambio_1": new FormControl(''),
            "tokenScambio_2": new FormControl(''),
            "tokenScambio_3": new FormControl(''),
            "tokenScambio_4": new FormControl(''),
            "tokenScambio_5": new FormControl(''),
            "tokenScambio_6": new FormControl(''),
            "tokenScambio_7": new FormControl(''),
            "tokenScambio_8": new FormControl(''),


            "tokenErratoScambio_1": new FormControl(''),
            "tokenErratoScambio_2": new FormControl(''),
            "tokenErratoScambio_3": new FormControl(''),
            "tokenErratoScambio_4": new FormControl(''),
            "tokenErratoScambio_5": new FormControl(''),
            "tokenErratoScambio_6": new FormControl(''),
            "tokenErratoScambio_7": new FormControl(''),
            "tokenErratoScambio_8": new FormControl(''),

            "feedbackScambio_1": new FormControl(''),
            "feedbackScambio_2": new FormControl(''),
            "feedbackScambio_3": new FormControl(''),
            "feedbackScambio_4": new FormControl(''),
            "feedbackScambio_5": new FormControl(''),
            "feedbackScambio_6": new FormControl(''),
            "feedbackScambio_7": new FormControl(''),
            "feedbackScambio_8": new FormControl('')

        });


        this.premiList = [

            //{ "value": "1", "testo": "Spam" },
            //{ "value": "2", "testo": "Phishing" },
            //{ "value": "3", "testo": "Calendario" },
            //{ "value": "4", "testo": "Attività da svolgere" },
            //{ "value": "5", "testo": "Scarica/Archivia allegato" },
            //{ "value": "6", "testo": "Rispondi al mittente" },

            { "value": "98", "testo": "TUTTE" }
            //{ "value": "99", "testo": "Screen Saver" },

        ]


    }

    baselineTest() {
        this.genericform.patchValue({
            tipo: 1,
            valoreIniziale: 9999,
            tipoScambio: 1,
            valoreInizialeScambio: 9999,
            tokenScambio_7: 0,
            tokenScambio_8: 0,
            tokenErratoScambio_7: 0,
            tokenErratoScambio_8: 0
        });
    }

    randomEmail() {
        for (var i = 0; i < this.emailsSelected.length; i++) {
            let item = this.emailsSelected[i];
            //item['start_delay'] = Utils.randomNumber(this.from_random, this.to_random);
            item['start_delay'] = 0;
        }
        this.emailsSelected = Utils.shuffle(this.emailsSelected);

    }



    _onAddClick(event) {

        // this.emailsSelected = [];
        // this.emailList = [];
        // for (var i = 0; i < this.emailListComplete.length; i++) {

        //     let item = this.emailListComplete[i];
        //     item['start_delay'] = 0;
        //     item['pBottoneOk'] = "";
        //     item['pBottoneKo'] = "";

        //     this.emailList.push(item);
        // }
    }

    _onSaveItem(event) {
        //Utils.log("ON_SAVE",event.value['id']);

        //Utils.log("EMAILS_SEL: ",this.emailsSelected);
        this.genericform.value["emails"] = this.emailsSelected;
    }

    _onLoadRow(event) {

        let premi = event['premi'];

        this.tempi = {};
        this.selectedPremi = [];
        for (var i = 0; i < premi.length; i++) {
            let premio = premi[i];
            this.tempi[premio] = true;
            this.selectedPremi.push(premio);
        }


        this.emailsSelected = [];
        this.emailList = [];

        let emailsObj = event['emailsObj'];
        var ids = {};

        for (var i = 0; i < emailsObj.length; i++) {
            let item = emailsObj[i];
            let email = item["email"];
            ids[email["id"]] = true;
            this.emailsSelected.push(email);
        }

        //Utils.log("IDs", ids);

        for (var i = 0; i < this.emailListComplete.length; i++) {

            let item = this.emailListComplete[i];
            let emailid = item['id'];
            if (ids[emailid] == true) {
                //this.emailsSelected.push(ids[emailid]);
            } else {
                item['start_delay'] = 0;
                this.emailList.push(item);
            }
        }



    }

    soloPulsantiChanged(event) {

    }

    tipoChanged(e) {


    }
    tipoScambioChanged(e) {
        let value = e.value;

    }

    checkoxChanged(e, item) {

        //Utils.log(item);

        if (e == false) {

            let key = "tempoPremio_" + item.value;
            let key1 = "costoPremio_" + item.value;

            // this.genericform.setValue({
            //     key: ""
            // });





        }

    }

    getLabelNonRichiederePassword(item) {

        if (item.testo == "TUTTE") {
            return "Non chiedere mai la password";
        }
        return "Non chiedere passowrd " + item.testo;

    }


}





// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/home/test.component.ts